export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/fortune.1ccb8306.svg","height":20,"width":88,"blurWidth":0,"blurHeight":0};